const closeDrawerNav = () => {
  $('.pv-top-nav-dropdown-item').removeClass('js-top-nav-item-visible js-top-nav-item-active');
};

$('.pv-top-nav-dropdown-item').on('click', function(e) {
  const item = $(this);
  if (e.target === item.get(0) || e.target === item.find('.nav-menu-item').get(0)) {
    if (!item.hasClass('js-top-nav-item-visible')) {
      // closes the search bar
      $('.menu-search').removeClass('js-search-show');
      $('.search-overlay').hide();
      // closes open nav bars
      item.siblings('.pv-top-nav-dropdown-item').removeClass('js-top-nav-item-visible js-top-nav-item-active');
    }
    // opens/closes the nav bar
    item.toggleClass('js-top-nav-item-visible js-top-nav-item-active');
  }
});

$('.search-toggle').on('click', () => {
  closeDrawerNav();
});

let lastOpenedDrawer = null;
$(window).on('scroll', () => {
  if ($(window).scrollTop() > 0) {
    $('.pv-top-nav-dropdown-item').each(function() {
      if ($(this).hasClass('js-top-nav-item-active')) {
        lastOpenedDrawer = $(this);
        closeDrawerNav();
      }
    });
  } else {
    lastOpenedDrawer.addClass('js-top-nav-item-active');
  }
});
